"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEnv = void 0;
var formatEnv = function (env) {
    return env.trim().toLowerCase();
};
exports.formatEnv = formatEnv;
//# sourceMappingURL=formatEnv.js.map